module.exports = __webpack_public_path__ + "img/img_placeholder.316f3d5b.jpg";